<template>
  <div>
    <keep-alive><Header></Header></keep-alive>
    <Search></Search>
    <div id="app">
      <router-view/>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/Header/Header'
import Search from './components/Search/Search'
import Footer from './components/Footer/Footer'
export default {
  name: 'App',
  components: {
    Header,
    Search,
    Footer
  }
}
</script>

<style lang="less" scoped>
#app {
  min-height: 500px;
}
 /deep/.select-option {
  .popper__arrow {
    left: 50%;
    margin-left: -3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue